// extracted by mini-css-extract-plugin
export default {"base":"vp_NmwYd","button":"vp_epkFr","label":"vp_zwEci","arrow":"vp_vNXBD","prominent":"vp_E4ijQ","active":"vp_xA1d5"};